import * as R from 'remeda';
import { createSlice } from '../../core';
import type { CameraSlice } from '../../core/camera';
import {
  constrainToViewport,
  getCanvasContext,
  translate,
  translateToPosition,
} from '../../core/camera';
import type { Point2D, Vector2D } from '../../core/utils';

export type PanSlice = {
  pan: {
    speed: number;
    bounded: boolean;
    actions: {
      panBy: (delta: Vector2D) => void;
      panTo: (pos: Partial<Point2D>) => void;
      setConfig: (config: Partial<{ speed: number; bounded: boolean }>) => void;
    };
  };
};

export const panSlice = createSlice<CameraSlice>()<PanSlice>((set, get) => ({
  pan: {
    speed: 1.0,
    bounded: true,
    actions: {
      setConfig: config =>
        set(state => ({
          ...state,
          pan: { ...state.pan, ...config },
        })),

      panBy: delta =>
        set(state => {
          const ctx = getCanvasContext(state.canvas);
          const { bounded } = get().pan;

          return {
            ...state,
            canvas: {
              ...state.canvas,
              transform: R.pipe(
                state.canvas.transform,
                translate(delta),
                // Only constrain if bounded is true
                t => (bounded ? constrainToViewport(ctx)(t) : t)
              ),
            },
          };
        }),

      panTo: pos =>
        set(state => {
          const ctx = getCanvasContext(state.canvas);
          const { bounded } = get().pan;

          return {
            ...state,
            canvas: {
              ...state.canvas,
              transform: R.pipe(
                state.canvas.transform,
                translateToPosition(pos),
                t => (bounded ? constrainToViewport(ctx)(t) : t)
              ),
            },
          };
        }),
    },
  },
}));
